module.exports = __webpack_public_path__ + "static/media/image-card-7.108a3192.png";